import React, { Component } from "react";
import SearchSelect from "../../../../../../components/searchSelect/SearchSelect";
import { InputFactory, dialog } from "nq-component";
import BaseListPage from "../../../../../../base/BaseListPage";
import Presenter from "../Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";

export default class EditOtherInfoForm extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      level: "",
      selectedLevel: "",
      schoolName: "",
      education: "",
      highest: "",
      scholarship: "",
      graduated: "",
    };
  }

  getCollectionName() {
    return "educational_background";
  }
  componentDidMount() {
    this.presenter.componentDidMount();
    const object = this.props.object;

    console.warn("GGGGG: ", object);

    this.setState({
      selectedLevel: object.educationLevel,
      schoolName: object.educationSchool,
      education: object.educationDegree,
      highest: object.educationHighest,
      scholarship: object.educationHonors,
      graduated: object.educationYear,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.props.object) {
    }
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleLevelChange(selectedLevel) {
    console.warn("FFFF: ", selectedLevel);
    this.setState({ selectedLevel });
  }

  onChangeSchoolName(schoolName) {
    this.setState({ schoolName });
  }
  onChangeEducation(education) {
    this.setState({ education });
  }
  onChangeHighest(highest) {
    this.setState({ highest });
  }

  onChangeScholarship(scholarship) {
    this.setState({ scholarship });
  }

  onChangeDateFrom(datefrom) {
    this.setState({ datefrom });
  }
  onChangeDateTo(dateto) {
    this.setState({ dateto });
  }
  onChangeGraduated(graduated) {
    this.setState({ graduated });
  }

  async handleSaveButton() {
    if (this.state.selectedLevel === "") {
      this.showError("Level is required");
    } else if (this.state.schoolName === "") {
      this.showError("Name of School is required");
    } else {
      const data = {
        email: this.props.email,
        empID: this.props.empID,
        educationLevel: this.state.selectedLevel,
        educationSchool: this.state.schoolName,
        educationDegree: this.state.education,
        educationHighest: this.state.highest,
        educationHonors: this.state.scholarship,
        educationFrom: this.state.datefrom,
        educationTo: this.state.dateto,
        educationYear: this.state.graduated,
        id: this.props.object.id,
      };
      console.warn("DATAAA: ", data);
      await this.presenter.upsertUseCase.execute(
        "educational_background",
        data
      );
      dialog.close();
      this.props.refetchData();
    }
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const { selectedLevel } = this.state;
    const object = this.props.object;
    const level = [
      "Elementary",
      "Secondary",
      "Vocational/Trade Course",
      "College",
      "Graduate Studies",
    ];

    return (
      <>
        <div>
          <h4>Add Educational Background</h4>
          <hr />
          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Level <span style={{ color: "red" }}>*</span>
          </label>
          <SearchSelect
            value={selectedLevel}
            onChange={this.handleLevelChange.bind(this)}
            options={level.map((level) => ({
              label: level,
              value: level,
            }))}
          />

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Name of School <span style={{ color: "red" }}>*</span>
          </label>
          <InputFactory
            type="String"
            field="educationSchool"
            object={object}
            onChange={this.onChangeSchoolName.bind(this)}
          />

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Basic Education/Degree/Course (Write in full)
          </label>
          <InputFactory
            type="String"
            field="educationDegree"
            object={object}
            onChange={this.onChangeEducation.bind(this)}
          />

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Highest Level/Units Earned (if not graduated)
          </label>
          <InputFactory
            type="String"
            object={object}
            field="educationHighest"
            onChange={this.onChangeHighest.bind(this)}
          />
          {/* <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Scholarship/Academic Honors Received
          </label>
          <InputFactory
            type="String"
            object={object}
            field="educationHonors"
            onChange={this.onChangeScholarship.bind(this)}
          /> */}

          <div style={{ margin: "1rem 0" }}>
            <h4>Add Educational Background</h4>
          </div>

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            From
          </label>
          <InputFactory
            type="Date"
            object={object}
            field="educationFrom"
            onChange={this.onChangeDateFrom.bind(this)}
          />
          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>To</label>
          <InputFactory
            type="Date"
            object={object}
            field="educationTo"
            onChange={this.onChangeDateTo.bind(this)}
          />

          <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
            Year Graduated
          </label>
          <InputFactory
            type="String"
            object={object}
            field="educationYear"
            onChange={this.onChangeGraduated.bind(this)}
          />

          <div className="mt-4 mb-4 d-flex justify-content-end">
            <button
              type="button"
              className="btn btn-light fs-sm me-3"
              onClick={() => dialog.close()}
            >
              Cancel
            </button>
            <button
              onClick={this.handleSaveButton.bind(this)}
              className="btn btn-primary fs-sm me-3"
            >
              Save
            </button>
          </div>
        </div>
      </>
    );
  }
}
